import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=b0aff644&scoped=true&"
import script from "./contactInfo.vue?vue&type=script&lang=js&"
export * from "./contactInfo.vue?vue&type=script&lang=js&"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=b0aff644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aff644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
